import React from 'react';

import { ReactComponent as EditIcon } from '../images/edit.svg';
import { ReactComponent as CloseIcon } from '../images/x.svg';
import { ReactComponent as TrafficIcon } from '../images/graph.svg';

const Widget = ({showTraffic, editUser, deleteUser}) => {
  return (
    <div style={{display: 'flex',
                 alignItems: 'center',
                 justifyContent: 'center',
                 cursor: 'pointer',
                 gap: '20px',
                }}>
      <TrafficIcon
        style={{width: '20px',
                height: '20px',
                fill: 'white',
                cursor: 'pointer',
               }}
        onClick={() => showTraffic() }
      />
      <EditIcon
        style={{width: '20px',
                height: '20px',
                fill: 'white',
                cursor: 'pointer',
               }}
        onClick={() => editUser() }
      />
      <CloseIcon
        style={{width: '20px',
                height: '20px',
                fill: 'red',
                cursor: 'pointer',
               }}
        onClick={() => deleteUser() }
      />
    </div>
  );
}

export default Widget;
